export class PortalConstants {
  static HideNavList: any[] = [
      { pageName: 'welcome', hideHeader: false, hideNavigation: true, hideBreadCrumb: true, showLogoOnly: true},
      { pageName: 'editaccountapplications' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'nxidigitaltransfer' , hideHeader: true, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'disclosure' , hideHeader: false, hideNavigation: false, showLogoOnly: true},
      { pageName: 'dt-welcome' , hideHeader: true, hideNavigation: true, hideBreadCrumb: true, hideFooter : true},
      { pageName: 'dt-consent' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true, hideQuickQuote: true, hideFooter : false, hideOpenAccountLink: true},
      { pageName: 'prospectAccount-login' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true, hideQuickQuote: true, hideFooter : false, hideOpenAccountLink: true},
      { pageName: 'prospectAccounts' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true, hideQuickQuote: true, hideFooter : false, hideOpenAccountLink: true},
      { pageName: 'dtAccountTransferConfirm' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true, hideQuickQuote: true,  hideFooter : true, hideOpenAccountLink: true},
      { pageName: 'digitaladvisesplash' , hideHeader: true, hideNavigation: true},
      { pageName: 'digitaladvisemixin' , hideHeader: true, hideNavigation: true},
      { pageName: 'account-types-nao' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'account-creation-info-nao' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'account-verid-nao' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'account-verid-nao-ng' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'account-new-userid-nao' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'account-status-nao' , hideHeader: false, hideNavigation: true, hideQuickQuote: true},
      { pageName: 'account-congrats-nao' , hideHeader: false, hideNavigation: true},
      { pageName: 'account-info-entry-nao' , hideHeader: false, hideNavigation: true, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'account-entry' , hideHeader: false, hideNavigation: true, hideQuickQuote: true, hideBreadCrumb: true, hideLogoutButton: true},
      { pageName: 'what-next' , hideHeader: false, hideNavigation: true, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'registration' , hideHeader: false, hideNavigation: true, showLogoOnly: true},
      { pageName: 'registration-check-status' , hideHeader: false, hideNavigation: true, showLogoOnly: true},
      { pageName: 'sso-logout' , hideHeader: false, hideNavigation: true, showLogoOnly: true, hideFooter : true},
      { pageName: 'theme-selector' , hideHeader: false, hideNavigation: true},
      { pageName: 'edelivery-promotion' , hideHeader: false, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true, hideOpenAccountLink: true},
      { pageName: 'edelivery-pending-enroll' , hideHeader: false, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true, hideOpenAccountLink: true},
      { pageName: 'redirectLandingPage' , hideHeader: true, hideNavigation: true},
      { pageName: 'manageuser' , hideHeader: true, hideNavigation: true, hideFooter : true},
      { pageName: 'billsuiteopener' , hideHeader: true, hideNavigation: true, hideFooter : true, hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'pay-bills-session-mgt' , hideHeader: true, hideNavigation: true, hideFooter : true,  hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'enroll-da' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideOpenAccountLink: true},
      { pageName: 'promo-da' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideOpenAccountLink: true},
      { pageName: 'modern-promo' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideOpenAccountLink: true},
      { pageName: 'wove-promo' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideOpenAccountLink: true},
      { pageName: 'promo-digauth' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideOpenAccountLink: true},
      { pageName: 'promo-aggregation' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideOpenAccountLink: true},
      { pageName: 'exchangeagreementoverview' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'exchangeagreementnps' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'exchangenysep' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'exchangenysenp' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'exchangeagnsdaq' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'exchangeagreementopra' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'exchangeagreementconfirm' , hideHeader: false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'childwindow' , hideHeader: true, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'link-accounts' , hideHeader: false, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true, hideBreadCrumb: true},
      { pageName: 'site-terms-and-conditions' , hideHeader: false, hideFooter: true, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'site-terms-and-conditions-declined' , hideHeader: false, hideFooter: true, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'cpwmclients' , hideHeader: true, hideFooter : true, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'cpbclients' , hideHeader: true, hideFooter : true, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'cpiiclients' , hideHeader: true, hideFooter : true, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'notice-of-bcp-disclaimer' , hideHeader: true, hideFooter : true, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'sms-terms-and-conditions' , hideHeader: true, hideFooter : true, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'add-fundstransfer' , hideHeader: false, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'digital-advise-mixin' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'digital-advise-splash' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'digital-portfolio-splash' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'digital-portfolio-goals' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'digital-portfolio-assessment' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'digital-portfolio-review' , hideHeader: false, hideNavigation: true, hideBreadCrumb: true},
      { pageName: 'fixed-income-inventory-popup' , hideHeader: true, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true, hideFooter : true},
      { pageName: 'digital-advice-landing' , hideHeader: true, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true, hideFooter : true},
      { pageName: 'midlogintc' , hideHeader: false, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'bmo-interstitial' , hideHeader: false, hideFooter : false, hideNavigation: true, hideLogoutButton: true, hideQuickQuote: true},
      { pageName: 'page-not-found' , hideHeader: false, hideFooter : false, hideNavigation: true, hideLogoutButton: false, hideQuickQuote: true}
  ];

  static PreloginPagesList: string[] = [
      'login',
      'login1',
      'login2',
      'welcome',
      'welcome1',
      'midlogin',
      'midloginsa',
      'saSetup',
      'otpSetup',
      'securityEmail',
      'changepwd',
      'otp',
      'sa',
      'updateSec',
      'setup',
      'setupQA',
      'changepassword',
      'nxi',
      'registration',
      'dt-welcome',
      'digital-advice-landing',
      'sso-logout',
      'registration-check-status',
      'account-new-userid-nao',
      'disclosure',
      'duplicatesessionconfirmation',
      'account-types-nao',
      'account-verid-nao',
      'account-verid-nao-ng',
      'user-id-creation-cao',
      'account-creation-info-nao',
      'digital-advise-splash',
      'digital-advise-mixin',
      'digital-portfolio-splash',
      'digital-portfolio-goals',
      'digital-portfolio-assessment',
      'digital-portfolio-review',
      'fixed-income-inventory-popup',
      'realtimetransfer',
      'notice-of-bcp-disclaimer',
      'cpwmclients',
      'cpbclients',
      'cpiiclients',
      'sms-terms-and-conditions',
      'nxidigitaltransfer',
      'resetpassword',
      'midlogintc',
      'midlogindasf',
      'bmo-interstitial',
      'duplicate'
  ];

  static PrePostloginPagesList: string[] = [
      'account-types-nao',
      'account-verid-nao',
      'account-creation-info-nao',
      'digital-advise-splash',
      'digital-advise-mixin',
      'digital-advice-landing',
      'digital-portfolio-splash',
      'digital-portfolio-goals',
      'digital-portfolio-assessment',
      'digital-portfolio-review',
      'fixed-income-inventory-popup',
      'realtimetransfer',
      'notice-of-bcp-disclaimer',
      'cpwmclients',
      'cpbclients',
      'cpiiclients',
      'sms-terms-and-conditions',
      'bmo-interstitial'
  ];

  static DoNotCheckRoutes: string[] = [
      'login',
      'login1',
      'login2',
      'midlogin',
      'dt-welcome',
      'midloginsa',
      'duplicatesessionconfirmation',
      'notice-of-bcp-disclaimer',
      'cpwmclients',
      'cpbclients',
      'cpiiclients',
      'manageuser',
      'nxidigitaltransfer',
      'midlogindasf'
      ];

  static LandingPageMap: any = {
      'theme-selector': '/nxi/theme-selector',
      'edelivery': '/nxi/edelivery-promotion',
      'edelivery-pending-enroll': '/nxi/edelivery-pending-enroll',
      'duplicatesessionconfirmation': '/nxi/duplicatesessionconfirmation',
      'promo-da': '/nxi/promo-da',
      'modern-promo': '/nxi/modern-promo',
      'wove-promo': '/nxi/wove-promo',
      'promo-digauth': '/nxi/promo-digauth',
      'digital-advice-landing': '/nxi/digital-advice-landing',
      'promo-aggregation': '/nxi/promo-aggregation',
      'account-verid-nao': '/nxi/account-verid-nao',
      'account-verid-nao-ng': '/nxi/account-verid-nao-ng',
      'account-status-nao': '/nxi/account-status-nao',
      'account-info-entry-nao': '/nxi/account-info-entry-nao',
      'digital-advise-splash': '/nxi/digital-advise-splash',
      'digital-advise-mixin': '/nxi/digital-advise-mixin',
      'digital-portfolio-splash': '/nxi/digital-portfolio-splash',
      'digital-portfolio-goals': '/nxi/digital-portfolio-goals',
      'digital-portfolio-assessment': '/nxi/digital-portfolio-assessment',
      'digital-portfolio-review': '/nxi/digital-portfolio-review',
      'realtimetransfer': '/nxi/realtimetransfer',
      'link-accounts' : '/nxi/link-accounts',
      'site-terms-and-conditions' : '/nxi/site-terms-and-conditions',
      'account-types-nao': 'nxi/account-types-nao',
      'add-fundstransfer': '/nxi/add-fundstransfer',
      'account-entry': '/nxi/account-entry',
      'dt-consent': 'nxi/dt-consent',
      'prospectAccount-login': 'prospectAccount-login',
      'allsettings':'/nxi/settings/allsettings',
      'bmo-interstitial': '/nxi/bmo-interstitial'
  };

  static PreLoginSessionTimeoutPages: string[] = [
      'midlogin',
      'duplicatesessionconfirmation',
      'account-types-nao',
      'account-creation-info-nao',
      'account-verid-nao',
      'account-verid-nao-ng',
      'account-verid-qa-nao',
      'account-new-userid-nao',
      'digital-advise-splash',
      'digital-advise-mixin',
      'digital-portfolio-splash',
      'digital-portfolio-goals',
      'digital-portfolio-assessment',
      'digital-portfolio-review',
      'registration',
      'dt-consent',
      'prospectAccount-login',
      'bmo-interstitial'
  ];
}
